<template>
  <div id="select_orang">
    <el-select ref="mySelect" v-model="currentValue" v-bind="$attrs" :remote-method="getOrgan" :loading="loading" filterable remote reserve-keyword style="width: 100%;" placeholder="输入商户名称" @change="change">
      <el-option v-for="item in organList" :key="`${item.name}option`" :label="item.name" :value="item.id" />
    </el-select>
  </div>
</template>

<script>
import { queryAllShop } from "@/api/seller";
export default {
  name: "OrgSelect",
  props: {
    defaultValue: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      shopId: "",
      organList: [],
      loading: false,
      currentValue: this.defaultValue
    };
  },
  methods: {
    // 获取商户
    getOrgan(name) {
      if (name) {
        this.loading = true;
        const data = {
          name,
          status: 2,
          pageNum: 1,
          pageSize: 1000
        };
        queryAllShop(data).then(d => {
          this.loading = false;
          if (d.code == 0) {
            this.organList = d.data;
          } else {
            this.organList = [];
          }
        });
      }
    },
    change() {
      this.$emit("getVal", this.currentValue);
    },
    reset() {
      this.organList = [];
      this.currentValue = "";
    }
  }
};
</script>
<style lang="scss" scoped>
#select_orang {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Selectorg/index.vue